import { createContainer } from 'unstated-next'
import usePermission from '../../../../../Helpers/CustomHooks/usePermission'

const MediaPermissionsStore = createContainer(() => {
  const microphonePermission = usePermission({ name: 'microphone' })
  const cameraPermission = usePermission({ name: 'camera' })

  return [cameraPermission, microphonePermission]
})

export default MediaPermissionsStore
